
/* 
 * Общие функции для Организаций
 * 
 * */

window.OK = (() => {
	"use strict";
	//dictionary
	const dic = {
		ORGANIZATION_FORMS: [{
				code: "fiz",
				value: "100731702",
				name: "Физическое лицо"
			},
			{
				code: "ip",
				value: "100679729",
				name: "Индивидуальный предприниматель"
			},
			{
				code: "ur",
				value: "100731703",
				name: "Юридическое лицо"
			}],
	}

	const api = {
		/**
		 * Получить данные по ИНН
		 * @param {type} payload
		 * @returns {HK=>#7.innUtils.getDataByInn.data}
		 */
		async getDataByInn(payload) {
			const {inn, sid} = {...payload};

			if (!inn) {
				return {success: false, error: "Не указан инн!"};
			}
			if (!sid) {
				return {success: false, error: "Ошибка передачи данных!"};
			}

			try {
				const response = await fetch("/ajax/getPartyData", {
					method: 'POST',
					headers: {
						'Content-Type': 'application/x-www-form-urlencoded',
						'X-Requested-With': 'XMLHttpRequest',
					},
					body: new URLSearchParams({
						inn: inn,
						sid: sid
					})
				});

				// Проверка статуса ответа
				if (!response.ok) {
					throw new Error(`HTTP ${response.status}: ${response.statusText}`);
				}

				const data = await response.json();

				PARAMS.isStage && console.info('[innUtils] Данные получены', data)

				// Если сервер вернул ошибку — выбрасываем исключение
				if (data?.error) {
					return {success: false, error: data.error};
				}

				// Флаг перезагрузки страницы
				if (data?.reload) {
					data._needsReload = true;
				}

				return {success: true, data: data};
			} catch (e) {
				const err = e.message || 'Ошибка получения данных по ИНН';
				await aAlert(err);
				return {success: false, error: err};
			}
		},

		/*
		 * Проверка ИНН в реквизитах получателя ИНН
		 * /ajax/checkRecipientInn
		 * {"success":true,"isBank":false,"message":"Некорректный ИНН"}
		 * 
		 */
		async checkRecipientInn(payload) {
			const {inn, sid} = {...payload};
			if (!inn) {
				return {success: false, error: "Не указан инн!"};
			}
			if (!sid) {
				return {success: false, error: "Ошибка передачи данных!"};
			}

			try {

				const response = await fetch("/ajax/checkRecipientInn", {
					method: "POST",
					headers: {"Content-Type": "application/json"},
					body: JSON.stringify(payload)
				});

				if (!response.ok) {
					throw new Error(`HTTP ${response.status}`);
				}

				const result = await response.json();

				if (!result.success || !result.data?.length) {
					return {success: false, error: "Нет данных"};
				}

				return result;
			} catch (e) {
				return {success: false, error: e};
			}
		},
	};


	// ═══════════════════════════════════════════════════════════════
	// СПИСОК ПОЛЕЙ ОРГАНИЗАЦИИ (Маппинг: Поле в сторе -> Ключ с бэкенда)
	// ═══════════════════════════════════════════════════════════════
	const ORGANIZATION_FIELDS_MAP = {
		ogrn: "ogrn",
		kpp: "kpp",
		legal_name: "full_name",
		title: "title",
		legal_address: "adres",
		famil: "famil",
		imya: "imya",
		otch: "otch",
	};


	// Функции обновления данных в объекте/хранилище
	const storeManipulations = {

		// чистим чистим чистим
		clearOrganizationData(params = {}) {
			const {
				store,
				fieldsPrefix = "",
				clearWithInn = false,
				clearWithSnils = false,
			} = params;

			if (!store) {
				return;
			}
			const F = (name) => fieldsPrefix + name; // Хелпер для формирования имен полей

			Object.keys(ORGANIZATION_FIELDS_MAP).forEach(field => {
				store[F(field)] = '';
			});
			if (clearWithInn && store[F("inn")]) {
				store[F("inn")] = '';
			}
			if (clearWithSnils && store[F("snils")]) {
				store[F("snils")] = '';
		}
		},

		// проверяем поля на существование в объекте
		isExistFields(params = {}) {
			const {store, fieldsPrefix = ""} = params;
			if (!store) {
				return false;
			}


			const F = (name) => fieldsPrefix + name;

			// Проверяем поля данных (с префиксом)
			for (const field of Object.keys(ORGANIZATION_FIELDS_MAP)) {
				if (typeof store[F(field)] === 'undefined') {
					console.error(`Поля ${F(field)} нет в хранилище`, store);
					return false;
				}
			}

			// Проверяем флаг автозаполнения (с префиксом)
			if (typeof store[F("is_party_data_autofilled")] === 'undefined') {
				console.error(`Поля ${F("is_party_data_autofilled")} нет в хранилище`, store);
				return false;
			}

			if (typeof store.partyDataLoading === 'undefined') {
				console.error(`Поля partyDataLoading нет в хранилище`, store);
				return false;
			}

			// Проверяем флаги типа организации (БЕЗ ПРЕФИКСА!)
			const flags = ["isFiz", "isUr", "isIp"];
			for (const flag of flags) {
				if (typeof store[flag] === 'undefined') {
					console.error(`Флага ${flag} нет в хранилище`, store);
					return false;
				}
			}
			return true;
		},

		/**
		 * Автозаполнение полей по ИНН
		 * Данные меняются по ссылке на объект (особенно эффективно с alpine хранилищем)
		 *
		 * @param {boolean} silent - не показывать уведомления
		 */
		async setDataByInn(params = {}) {
			const {
				silent = false,
				store,
				fieldsPrefix = "",
				sid = PARAMS?.SID ?? null,
				localCheckFunc = store?.validateField?.bind(store) ?? (async () => ({isValid: true})),
			} = params;
			if (!store) {
				return false;
			}
			if (!sid) {
				console.error("[OK.getInnAutoData] Не указан sid!");
				return false;
			}
			if (!this.isExistFields(params)) {
				return false;
			}


			const F = (name) => fieldsPrefix + name;

			// Если в тихом режиме вызываем функцию, то будет работать когда режим автозаполнения (onchange)
			if (silent && !store[F("is_party_data_autofilled")]) {
				return false;
			}

			// Физ. лицо - выходим
			if (store.isFiz) {
				store[F("is_party_data_autofilled")] = false;
				return false;
			}
			
			// Валидация ИНН
			const localCheck = await localCheckFunc(F("inn"));
			if (localCheck.isValid === false) {
				if (!silent) {
					aAlert(localCheck?.error?.message ?? "Некорректный ИНН!");
					return false;
				} else if (!store[F("is_party_data_autofilled")]) {
					this.clearOrganizationData(params);
				}
				return false;
			}

			const innVal = store[F("inn")];
			const innStr = String(innVal || "");

			// Проверка длины ИНН для ЮР лица
			if (store.isUr && innStr.length === 12) {
				if (!silent) {
					aAlert("Укажите ИНН юридического лица!");
				}

				return false;
			}


			// Проверка длины ИНН для ИП
			if (store.isIp && innStr.length === 10) {
				if (!silent) {
					aAlert("Укажите ИНН индивидуального предпринимателя!");
				}

				return false;
			}


			const payload = {inn: innVal, sid: sid};

			const handleError = (e) => {
				const attention = ` Проверьте тип ${CTX()?.comp?.dolz_a || 'организации'} и правильность ввода ИНН.`;
				const msg = (e?.message || e || "Неизвестная ошибка") + attention;

				if (store[F("is_party_data_autofilled")]) {
					this.setManualInnDataRegime({
						store,
						fieldsPrefix,
						silent: false,
						confirmText: msg + "<br>Ввести реквизиты вручную?"
					});
				} else {
					if (!silent) {
						aAlert(msg);
					}
				}
			};


			try {
				store.partyDataLoading = true;
				const result = await api.getDataByInn(payload);

				if (result.success) {
					const data = result.data || {};

					// Заполняем поля из единого списка
					Object.entries(ORGANIZATION_FIELDS_MAP).forEach(([storeField, backendKey]) => {
						store[F(storeField)] = data[backendKey] || "";
					});

					store[F("is_party_data_autofilled")] = true; // ставим то что заполнили автоматически
				} else {
					handleError(result.error);
				}

				if (result?.data?._needsReload) {
					window.location.reload();
					return true;
				}

				return !!result.success;
			} catch (e) {
				console.error(e);
				handleError(e);
				return false;
			} finally {
				store.partyDataLoading = false;
		}
		},
		/**
		 * Переключение в режим ручного ввода реквизитов
		 * Нажатие на кнопку ввести все данные вручную
		 */
		setManualInnDataRegime(params = {}) {
			const {
				store,
				fieldsPrefix = "",
				silent = false,
				confirmText = "Вы действительно хотите ввести реквизиты вручную?"
			} = params;

			if (!store) {
				return false;
			}


			const F = (name) => fieldsPrefix + name;
			const autoFilledField = F("is_party_data_autofilled");

			if (!silent) {
				aConfirm(confirmText).then((response) => {
					if (response) {
						store[autoFilledField] = false; // ставим маркер, что вручную вводим
					}
				});
				return false;
			}
			store[autoFilledField] = false;
			return false;
		},
	};


	// то, что будет доступно снаружи
	const publicAPI = {
		...api,
		...storeManipulations,
		...dic,
	};

	return publicAPI;
})();